import type { FC } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { VisibilityOutlined } from '@mui/icons-material';
import { useAnchorMenu } from '../../../hooks';
import useFacebookAdsLibraryParams from '../hooks/useFacebookAdsLibraryParams';

const CreativePreviewMode: FC = () => {
  const menu = useAnchorMenu();
  const { setAllExpanded } = useFacebookAdsLibraryParams();

  return (
    <>
      <IconButton onClick={menu.handleOpenMenu}>
        <VisibilityOutlined />
      </IconButton>
      <Menu
        anchorEl={menu.anchor}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={menu.isOpen}
        onClose={menu.handleCloseMenu}
      >
        <MenuItem
          onClick={() => {
            setAllExpanded(false);
            menu.handleCloseMenu();
          }}
        >
          Only preview
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAllExpanded(true);
            menu.handleCloseMenu();
          }}
        >
          Preview and details
        </MenuItem>
      </Menu>
    </>
  );
};

export default CreativePreviewMode;
